import React from "react";
import useCeo from "../../hooks/useCEO";
import { ListadoUnidades } from "../../components/EnRuta/ListadoUnidades";

export const EnRuta = () => {
  useCeo({
    title: "En Ruta",
    description: "Página de En Ruta",
  });

  return (
    <>
      <div className="row">
        <div className="col-12 padding-container" id="columna1">
          <ListadoUnidades busqueda={2}></ListadoUnidades>
        </div>
      </div>
    </>
  );
};
